import { NAME_CHARS } from "widgets/forms/validators/LibraryProperties";

export const CREATE = "create";
export const EDIT = "edit";

export const tooltipProps = {
	inline:false,
	direction: "right",
	size:"large",
	iconSize:"small",
};

export const textTooltips = {
	...tooltipProps,
	description:"Allowed characters: a-z, A-Z, 0-9, _, ', @, &, %, -, space, comma, period",
};

export const includeUmlauts = {
	...tooltipProps,
	description: "Allowed characters: Alpha-numeric, À-Ö, Ø-ö, ø-ÿ, _+.:()/«»!&~@#$%^*=|-\\",
};

export const libraryNameTooltipProps = {
	...tooltipProps,
	description:`Allowed characters: ${NAME_CHARS}`,
};
